import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setPageTitle } from "../../slice";

function TicketingCard({ icon, label, id }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Box
      width="258px"
      height="150px"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      boxShadow=" 0px 6px 14px rgba(158, 158, 158, 0.24)"
      borderRadius={3}
      mx={1}
      sx={{
        cursor: "pointer",
      }}
      onClick={() => {
        dispatch(setPageTitle(label));
        navigate(`/complaints/${id}`);
      }}
    >
      {icon}
      <Typography variant="h2" mt={3} textAlign="center">
        {label}
      </Typography>
    </Box>
  );
}

export default TicketingCard;
